import { Dialog, DialogContent, DialogTitle } from '@startuptools/ui/Dialog';
import { ErrorBoundary } from '@startuptools/ui/ErrorBoundary';
import { SubPicker } from './SubPicker';
import { Suspense } from 'react';

interface Props {
  open: boolean;
  cancel: () => void;
  onSubSelected: (subPriceId: string, prodId: string) => Promise<boolean>;
  disableStartup?: boolean;
}

export function SubPickerDialog({ open = false, cancel, onSubSelected, disableStartup = false }: Props) {
  if (!open) {
    return null;
  }
  return (
    <Dialog open={open} maxWidth="xl">
      <DialogTitle onClose={cancel}>Välj en kontoplan</DialogTitle>
      <DialogContent>
        <Suspense>
          <ErrorBoundary>
            <SubPicker {...{ onSubSelected, disableStartup }} />
          </ErrorBoundary>
        </Suspense>
      </DialogContent>
    </Dialog>
  );
}
